import { defineConfig } from '@stackflow/config';
import { z } from 'zod/v4';

import { activityDescription } from '@/stackflow/metadata';
import { objectEntries } from '@/utils/object';

export const stackflowTransitionDuration = 350;

export const stackflowConfig = defineConfig({
  activities: objectEntries(activityDescription).map(([name, { schema, url }]) => ({
    name,
    route: {
      path: url,
      decode: schema.parse,
    },
    // loader:
  })),
  transitionDuration: stackflowTransitionDuration,
});

type ActivityDescription = typeof activityDescription;
type ExtendedRegister = {
  [K in keyof ActivityDescription]: z.output<ActivityDescription[K]['schema']>;
};
declare module '@stackflow/config' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  interface Register extends ExtendedRegister {}
}
